<div class="col-sm-12 durationFiletr">
  <form [formGroup]="expiredListingsFilter">
    <div class="filter-row">
      <span class="active-duration-label"><strong>Expired in the last:</strong> </span>

      <mat-form-field class="active-duration-value">
        <input type="number" formControlName="duration" matInput placeholder="days" />
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        (click)="filterExpiredListings()"
        [disabled]="expiredListingsFilter.invalid || !expiredListingsFilter.get('duration')?.value"
      >
        Filter
      </button>
      <button mat-button color="primary" mat-stroked-button class="" (click)="resetFilter()" [disabled]="!canReset()">
        Reset
      </button>
    </div>
  </form>
</div>

<div class="col-lg-12 mt-3 table-csv-file">
  <div class="table_base">
    <div class="table-responsive table_wrap">
      <table mat-table [dataSource]="expiredListingsDataSource" matSort class="mat-elevation-z2 w-100">
        <!-- Address -->
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
          <td mat-cell *matCellDef="let element">
            <span
              *ngIf="getAddressComponentsFromStandardAddress(element.StdAddress) as addr"
              (click)="viewProperty(addr); $event.stopPropagation()"
            >
              {{ element.StdAddress.UnparsedAddress }},{{ element.StdAddress.City }},{{
                element.StdAddress.StateOrProvince
              }},{{ element.StdAddress.PostalCode }}</span
            >
          </td>
        </ng-container>

        <!-- Property Type -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Property Type</th>
          <td mat-cell *matCellDef="let element">
            {{ element.PropertyType ? element.PropertyType : '--' }}
          </td>
        </ng-container>

        <!-- Listed On -->
        <ng-container matColumnDef="listedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Listed On</th>
          <td mat-cell *matCellDef="let element">
            {{ element.ListingContractDate | simpleDate }}
          </td>
        </ng-container>

        <!-- DOM -->
        <ng-container matColumnDef="dom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>DOM</th>
          <td mat-cell *matCellDef="let element">
            {{ element.DaysOnMarket ? element.DaysOnMarket : '--' }}
          </td>
        </ng-container>

        <!-- Listed Price -->
        <ng-container matColumnDef="listedPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Listed Price</th>
          <td mat-cell *matCellDef="let element">
            {{ element.ListPrice ? (element.ListPrice | currency: 'USD':'symbol':'1.0-0') : '--' }}
          </td>
        </ng-container>

        <!-- Owner -->
        <ng-container matColumnDef="owner">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner</th>
          <td mat-cell *matCellDef="let element">
            {{ element.OwnerName ? element.OwnerName : '--' }}
          </td>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">
            {{ element.ownerEmail ? element.ownerEmail : '--' }}
          </td>
        </ng-container>

        <!-- Current Price -->
        <ng-container matColumnDef="currentPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Price</th>
          <td mat-cell *matCellDef="let element">
            {{ element.currentAvm ? (element.currentAvm | currency: 'USD':'symbol':'1.0-0') : '--' }}
          </td>
        </ng-container>

        <!-- Price Reduction -->
        <ng-container matColumnDef="priceReduction">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Price Reduction</th>
          <td mat-cell *matCellDef="let element">
            {{ element.PriceReduced ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <!-- Equity -->
        <ng-container matColumnDef="equity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Equity</th>
          <td mat-cell *matCellDef="let element">
            {{ element.equity ? element.equity : '--' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="sendMail">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Send Mail"
              (click)="actions(element, 'expiredListings'); $event.stopPropagation()"
            >
              <mat-icon>mail</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="actions(row, 'editEmail')"
          class="clickable-row"
        ></tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>

<!-- Loader -->
<div class="section-in-progress" *ngIf="isDataLoading">
  <mat-spinner diameter="30" class="mr-3"></mat-spinner>
  Please wait while we load
</div>

<div class="flex_center w-100" *ngIf="expiredListingsDataSource.data?.length === 0">
  <div class="notFound text-center noData">
    <div>
      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
      <h4>No Expired Listings Found</h4>
    </div>
  </div>
</div>
